<template>
  <div class="service-listing">
    <div class="container">
      <div class="row">
        <!--slider-->
        <div class="col-12 responsive-cancel-padding tablet-full-width">
          <service-slider-component
            :allCat="allCategories"
            :filerSlider="filterData"
            @selectSliderId="(sliderId = $event), (slideClicked = true)"
            v-if="allCategories.length != 0"
          />
        </div>

        <!--tabs filter-->
        <div class="col-12">
          <b-tabs content-class="mt-3" justified>
            <b-tab
              v-for="tab in tabs"
              :key="tab.id"
              :title="tab.title"
              @click="tabChange(tab.id)"
            >
            </b-tab>
          </b-tabs>
        </div>

        <!--filter component-->
        <div
          class="col-xs-3 col-lg-3 responsive-cancel-padding cancel-left-padding tablet-full-width"
          v-if="!roadMap"
        >
          <div class="filter-component">
            <filterservice
              :apiResponse="info"
              :filter="filterData"
              @depArr="depArr = $event"
              @categoryArr="cateArr = $event"
              @sectorArr="sectorArr = $event"
              @subArr="subArr = $event"
              @healthArr="healthArr = $event"
              @funcArr="funcArr = $event"
              @ruleArr="ruleArr = $event"
              @tarckApplyFilter="tarckApplyFilter = true"
              :filterClicked="tarckApplyFilter"
              :PageType="PageType"
              :rules="rules"
              :announcement="announcement"
              :services="services"
              v-if="info"
              :sectorLab="SectorLabel"
              :categoryLab="CategoryLabel"
              :productLab="ProductsLabel"
              :functionsLab="FunctionsLabel"
              :searchLab="SearchLabel"
              :CategoriesOfRules="CategoriesOfRules"
              @datestart="datestart = $event"
              @dateend="dateend = $event"
              @resetDate="resetDate = $event"
              :ClearDateFilter="ClearDateFilter"
              :FilterByDate="FilterByDate"
              :Apply="Apply"
              :Reset="Reset"
              :From="From"
              :key="reinitFilter"
              :To="To"
              :BackBtn="BackBtn"
              :Required="Required"
            />
            <div class="generic-loader filter-loader" v-if="apiCallLoader">
              <img
                src="../../../../Assets/Images/spinner.svg"
                alt="EDA Spinner"
              />
            </div>
          </div>
        </div>

        <div class="col-12 road-map" v-if="roadMap">
          <h3 v-if="roadMapFlag" class="empty-msg">
            {{ NoResultMessage }}
          </h3>
          <div class="road-map-section" v-if="data.RoadMaps.length != 0">
            <road-map :roadMapArr="data.RoadMaps"></road-map>
          </div>
        </div>

        <div
          class="col-xs-9 col-lg-9 responsive-cancel-padding tablet-full-width"
          v-if="!roadMap"
        >
          <div class="accordion-wrapper">
            <!--search component-->
            <servicesearch
              @searchKeyword="(searchWord = $event), (searchClicked = true)"
              :searchFilter="filterData"
              :searchLab="SearchLabel"
              :searchPlaceHolder="SearchPlaceHolder"
              :key="reinitFilter"
            />

            <!--announcement component-->
            <div class="accordion" id="accordionExample" v-if="announcement">
              <h3
                v-show="filteredData.Announcements.length == 0"
                class="empty-msg"
              >
                {{ NoResultMessage }}
              </h3>
              <div v-if="filteredData.Announcements.length != 0">
                <Announcement-card
                  :AnnouncementArr="filteredData.Announcements"
                ></Announcement-card>
              </div>
            </div>

            <!--Rules And Regulations component-->
            <div class="accordion" id="accordionExample" v-if="rules">
              <h3
                v-show="filteredData.RulesAndRegulations.length == 0"
                class="empty-msg"
              >
                {{ NoResultMessage }}
              </h3>
              <div v-if="filteredData.RulesAndRegulations.length != 0">
                <rules-regulations
                  :rulesRegulations="filteredData.RulesAndRegulations"
                  :download="Download"
                ></rules-regulations>
              </div>
            </div>

            <!--services component-->
            <div
              class="accordion"
              id="accordionExample"
              aria-multiselectable="true"
              v-if="services"
            >
              <h3 v-if="servicesNoData" class="empty-msg">
                {{ NoResultMessage }}
              </h3>
              <div v-if="!servicesNoData">
                <Service-card
                  :serviceCardObj="serviceObj"
                  :serviceCardArr="filteredData"
                  :mobileView="mobileView"
                ></Service-card>
              </div>
            </div>

            <!--loader-->
            <div class="generic-loader" v-show="isAjaxLoading">
              <img
                src="../../../../Assets/Images/spinner.svg"
                alt="EDA Spinner"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filterservice from "../../GenericPageComponent/Filter/FilterService.vue";
import servicesearch from "../../GenericPageComponent/ServiceSearch/ServiceSearch.vue";
import serviceSliderComponent from "../../GenericPageComponent/ServiceSlider/ServiceSliderComponent.vue";
import ServiceCard from "../../GenericListingComponent/ServicesBlock/ServiceCard.vue";
import AnnouncementCard from "../../GenericListingComponent/AnnouncementBlock/AnnouncementCard.vue";
import rulesRegulations from "../../GenericListingComponent/RulesAndRegulationsBlock/RulesAndRegulations.vue";
import roadMap from "../../GenericListingComponent/RoadMap/RoadMap.vue";
import Vue from "vue";
import axios from "axios";
import BTab from "bootstrap-vue";

Vue.use(BTab, axios);

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;

export default {
  props: [
    "SectorLabel",
    "CategoryLabel",
    "ProductsLabel",
    "FunctionsLabel",
    "SearchLabel",
    "SearchPlaceHolder",
    "PageType",
    "tabs",
    "ClearDateFilter",
    "FilterByDate",
    "From",
    "To",
    "Required",
    "NoResultMessage",
    "CategoriesOfRules",
    "Download",
    "Apply",
    "Reset",
    "ServiceCost",
    "CentralAdministration",
    "PublicAdministration",
    "Specialization",
    "Cosmetic",
    "SecondaryCategory",
    "Category",
    "BackBtn",
  ],
  components: {
    filterservice,
    serviceSliderComponent,
    servicesearch,
    ServiceCard,
    AnnouncementCard,
    rulesRegulations,
    roadMap,
  },
  data() {
    return {
      tabIndex: 0,
      pageNumber: 1,
      searchWord: "",
      sliderId: "",
      slideClicked: false,
      searchClicked: false,
      returnedNameFilter: null,
      info: null,
      allCategories: [],
      userIds: [],
      data: {
        RoadMaps: [],
        Services: [],
        Announcements: [],
        RulesAndRegulations: [],
      },
      cateArr: [],
      ruleArr: [],
      sectorArr: [],
      subArr: [],
      healthArr: [],
      funcArr: [],
      depArr: [],
      tarckApplyFilter: false,
      isAjaxLoading: true,
      filteredData: {
        Services: [],
        Announcements: [],
        RulesAndRegulations: [],
      },
      limit: 10,
      roadMapFlag: false,
      roadMap: true,
      services: false,
      rules: false,
      announcement: false,
      mobileView: false,
      reinitFilter: 0,
      filter: [],
      tabClicked: false,
      pageLoad: true,
      serviceObj: {},
      servicesNoData: false,
      rulesNoData: false,
      announcementNoData: false,
      apiCallLoader: false,
    };
  },
  methods: {
    tabChange(id) {
      this.tabClicked = true;

      this.getInfo();

      this.roadMap = false;
      this.services = false;
      this.rules = false;
      this.announcement = false;
      if (id == 0) {
        this.roadMap = true;
      }
      if (id == 1) {
        this.services = true;
      }
      if (id == 2) {
        this.rules = true;
      }
      if (id == 3) {
        this.announcement = true;
      }
    },
    getInfo() {
      axios
        .post(
          `${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?pageType=${this.PageType}&culture=${language}`
        )
        .then((response) => {
          this.info = response.data;
          this.allCategories = this.info.FilterationItems;

          if (this.pageLoad == true) {
            this.sliderId = this.info.FilterationItems[0].Id;
          }

          if (this.pageLoad == true || this.tabClicked) {
            this.filterData();
          }

          for (let item of this.info.Categories) {
            this.$set(item, "checked", false);
            item.SubCategories = item.SubCategories.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.Sectors) {
            this.$set(item, "checked", false);
            item.Department = item.Department.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.HealthProducts) {
            this.$set(item, "checked", false);
          }

          for (let item of this.info.Functions) {
            this.$set(item, "checked", false);
          }

          this.pageLoad = false;
          if (this.tabClicked) {
            this.tabClicked = false;
          }
        });
    },
    async filterData() {
      this.isAjaxLoading = true;
      this.roadMapFlag = false;
      this.servicesNoData = false;
      this.announcementNoData = false;
      this.rulesNoData = false;
      let categoriesArr = [];

      if (this.rules) {
        categoriesArr = this.ruleArr;
      } else {
        categoriesArr = this.cateArr;
      }

      this.data = {
        RoadMaps: [],
        Services: [],
        Announcements: [],
        RulesAndRegulations: [],
      };

      if (this.slideClicked) {
        this.getInfo();
      }

      if (
        this.searchWord ||
        this.slideClicked ||
        this.tarckApplyFilter == true
      ) {
        this.pageNumber = 1;
        this.filteredData.Services = [];
      }

      if (this.searchClicked) {
        this.pageNumber = 1;
        this.filteredData.Services = [];
      }

      if (this.tarckApplyFilter) {
        if (window.innerWidth > 1025) {
          this.apiCallLoader = true;
        }
      }

      if (this.slideClicked || this.tabClicked) {
        this.pageNumber = 1;
        this.reinitFilter += 1;
        this.filteredData.Services = [];
        this.datestart = ""; //js Date
        this.dateend = "";
        this.searchWord = "";
        this.cateArr = [];
        this.healthArr = [];
        this.funcArr = [];
        this.subArr = [];
        this.depArr = [];
        this.sectorArr = [];
        categoriesArr = [];
      }

      let axiosData = {
        PageType: this.PageType,
        SelectedItemId: this.sliderId, //item id of slider
        Text: this.searchWord,
        PageNumber: this.pageNumber,
        DateFrom: this.datestart, //js Date
        DateTo: this.dateend,
        Categories: categoriesArr,
        HealthProducts: this.healthArr,
        Functions: this.funcArr,
        SubCategories: this.subArr,
        Departments: this.depArr,
        Sectors: this.sectorArr,
      };

      await axios
        .post(
          `${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`,
          axiosData
        )
        .then((response) => {
          this.apiCallLoader = false;
          this.isAjaxLoading = false;

          this.tabClicked = false;
          this.tarckApplyFilter = false;
          this.slideClicked = false;
          this.searchClicked = false;

          this.data = response.data;

          //this.data.RoadMaps = [this.data.RoadMaps[0]];

          //check if roadmap
          if (this.data.RoadMaps) {
            if (this.data.RoadMaps.length != 0) {
              this.roadMapFlag = false;
            } else {
              this.roadMapFlag = true;
            }
          } else {
            this.roadMapFlag = false;
          }

          //check if services
          if (this.data.Services.length != 0) {
            if (this.pageNumber == 1) {
              this.filteredData.Services = this.data.Services;
            } else {
              this.filteredData.Services = this.filteredData.Services.concat(
                this.data.Services
              );
            }
          } else {
            if (this.filteredData.Services.length != 0) {
              this.servicesNoData = false;
            } else {
              this.servicesNoData = true;
            }
          }

          //check if Announcements
          if (this.data.Announcements.length != 0) {
            if (this.pageNumber == 1) {
              this.filteredData.Announcements = this.data.Announcements;
            } else {
              this.filteredData.Announcements =
                this.filteredData.Announcements.concat(this.data.Announcements);
            }
          } else {
            if (this.filteredData.Announcements.length != 0) {
              this.announcementNoData = false;
            } else {
              this.announcementNoData = true;
            }
          }

          //check if RulesAndRegulations
          if (this.data.RulesAndRegulations.length != 0) {
            if (this.pageNumber == 1) {
              this.filteredData.RulesAndRegulations =
                this.data.RulesAndRegulations;
            } else {
              this.filteredData.RulesAndRegulations =
                this.filteredData.RulesAndRegulations.concat(
                  this.data.RulesAndRegulations
                );
            }
          } else {
            if (this.filteredData.RulesAndRegulations.length != 0) {
              this.rulesNoData = false;
            } else {
              this.filteredData.RulesAndRegulations = [];
              this.rulesNoData = true;
            }
          }

          if (this.pageNumber == 1) {
            if (!this.data.Announcements.length)
              this.filteredData.Announcements = [];
            if (!this.data.Services.length) this.filteredData.Services = [];
            if (!this.data.RulesAndRegulations.length)
              this.filteredData.RulesAndRegulations = [];
          }
        })
        .catch(() => {});
    },
    slice(listingArray, apiListing) {
      listingArray = listingArray.concat(apiListing);
      return listingArray;
    },
    checkTrigger() {
      const options = {
        threshold: 0.1,
      };
      const checker = document.querySelector(".footer");
      const infiniteScroll = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.data.Services.length != 0) {
              this.isAjaxLoading = true;
              if (window.innerWidth > 1025) {
                this.apiCallLoader = true;
              }
              setTimeout(() => {
                this.pageNumber++;
                this.filterData();
                this.isAjaxLoading = false;
              }, 500);
            }
          }
        });
      };

      const observer = new IntersectionObserver(infiniteScroll, options);
      observer.observe(checker);
    },
    getSliderId(value) {
      this.sliderId = value;
    },
  },
  beforeMount() {
    //check page type
    if (this.PageType === "functions") {
      this.tabIndex = 1;
      this.roadMap = false;
      this.services = true;
    }
  },
  mounted() {
    this.getInfo();
    document.querySelector(".register-page-form__loader").style.display =
      "none";
    if (window.innerWidth < 768) {
      this.mobileView = true;
    }

    this.serviceObj = {
      ServiceCost: this.ServiceCost,
      CentralAdministration: this.CentralAdministration,
      PublicAdministration: this.PublicAdministration,
      Specialization: this.Specialization,
      Cosmetic: this.Cosmetic,
      SecondaryCategory: this.SecondaryCategory,
      Category: this.Category,
    };
    setTimeout(() => {
      this.checkTrigger();
    }, 500);
  },
};
</script>
